import { IDPUserResponse } from 'Shared/models/swagger/idp';

enum IDPSignupSource {
  DIRECT   = "DIRECT",
  FACEBOOK = "FACEBOOK",
  GOOGLE   = "GOOGLE",
  APPLE    = "APPLE",
}

/**
 * The `IDPUserResponseInternal` interface extends `IDPUserResponse` which is auto-generated. This is done to adapt date fields for internal use.
 * While `IDPUserResponse` matches the API's Swagger definitions with date fields as ISO 8601 strings,
 * `IDPUserResponseInternal` uses `Date` objects for these fields to simplify date manipulations within the app.
 */
interface IDPUserResponseInternal extends Omit<IDPUserResponse, 'lastLogin' | 'lastSeenAt' | 'createdAt' | 'updatedAt' | 'dateOfBirth'> {
  lastLogin?: Date | null;
  lastSeenAt?: Date | null;
  createdAt: Date;
  updatedAt?: Date | null;
  dateOfBirth?: Date | null;
}

export {
  IDPSignupSource,
  IDPUserResponseInternal
};

